import { usersRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const usersRouteMetadata: IRouteMetadataObj<typeof usersRoutesObj> = {
  list: {
    title: "users.index.title",
    description: "users.index.description",
    lazy: () => import("@/pages/userManagement/users/table/page"),
    mode: "index",
    type: "main",
    icon: "GroupLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher],
  },
  create: {
    title: "users.teacher.create.title",
    description: "users.teacher.create.description",
    lazy: () => import("@/pages/userManagement/teachers/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN],
  },
  edit: {
    title: "users.teacher.edit.title",
    description: "users.teacher.edit.description",
    lazy: () => import("@/pages/userManagement/teachers/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    // TODO : will remove after the fixing URL to view mode  , just testing work or not
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.ASSISTANT, IRoleEnum.Teacher],
  },
  view: {
    title: "users.teacher.view.title",
    description: "users.teacher.view.description",
    lazy: () => import("@/pages/userManagement/teachers/form/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.ASSISTANT, IRoleEnum.Teacher],
  },
};

export const usersRoutes = createRoute<typeof usersRoutesObj>(
  usersRoutesObj,
  usersRouteMetadata,
);
